import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import queryString from 'query-string'
import Input from '../../views/Input/Input'
import Output from '../../views/Output/Output'
import { RenderIf } from '../../../../utils/fns'
import { ResetButton } from '../../../../legacy/components/ResetButton'
import { SECTION_PANEL } from '../../../../utils/constants'

const views = {
  [SECTION_PANEL.INPUT]: (props) => <Input {...props} />,
  [SECTION_PANEL.OUTPUT]: (props) => <Output {...props} />,
}

const MOBILE_NAVIGATION_BTN = [
  {
    label: 'Input',
    value: SECTION_PANEL.INPUT,
  },
  { label: 'Output', value: SECTION_PANEL.OUTPUT },
]

const MobileView = () => {
  const dispatch = useDispatch()

  const [screen, setScreen] = useState(SECTION_PANEL.INPUT)

  const params = window.location.search ? queryString.parse(window.location.search) : {}

  const handleNavigation = (value) => setScreen(value)

  const handleMobileViewOrderClick = () => {
    dispatch({ type: 'MOBILEVIEW_ORDER' })
  }

  useEffect(() => {
    const mediaClass = '-media-xs'
    document.documentElement.classList.remove('-media-sm', '-media-md', '-media-lg')
    document.documentElement.classList.add(mediaClass)
  }, [])

  return (
    <React.Fragment>
      <div className="mobileSectionTabGroup">
        {MOBILE_NAVIGATION_BTN.map((item) => (
          <button
            type="button"
            key={item.value}
            value={item.value}
            className={`button mobileSectionTabButton inputOutputSelect ${
              screen === item.value ? '-active' : ''
            }`}
            onClick={() => handleNavigation(item.value)}
          >
            {item.label}
          </button>
        ))}
      </div>

      {React.createElement(views[screen])}

      <div className="workspaceButtonGroup">
        <ResetButton />

        {RenderIf(
          params?.source === 'EC' && screen === SECTION_PANEL.OUTPUT,
          <button className="button -fab -order" onClick={handleMobileViewOrderClick}>
            Order
          </button>,
        )}
      </div>
    </React.Fragment>
  )
}

export default MobileView
